import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAccessControl } from '../hooks/useAccessControl';
import { getPricingContext } from '../utils/pricingDisplay';
import PricingCatalog from './Pricing/PricingCatalog';
import PricingDialog from './Pricing/PricingDialog';
import usePricingCheckout from './Pricing/usePricingCheckout';

export default function UpgradeModal({ isOpen, onClose, requiredFeature, featureDisplayName }) {
  const location = useLocation();
  const { productTypes, planId } = useAccessControl();
  const checkout = usePricingCheckout();
  const product = productTypes.includes('bundle') ? 'bundle' : productTypes.includes('ats') ? 'ats' :
    productTypes.includes('tse') ? 'tse' : getPricingContext(location.pathname);
  const products = product === 'bundle' ? ['bundle'] : [product, 'bundle'];
  return <PricingDialog isOpen={isOpen} onClose={onClose}>
    <PricingCatalog defaultProduct={product} products={products} currentPlanId={planId}
      requiredFeature={requiredFeature} featureDisplayName={featureDisplayName}
      onSelectPlan={checkout.selectPlan} pendingPlan={checkout.pendingPlan} error={checkout.error} />
  </PricingDialog>;
}
